import logo from "../images/logo.svg";
import menu from "../images/icon-hamburger.svg";
import closeicon from "../images/icon-close.svg";
import React, { useState } from "react";

const Navbar = ({ setMobilenavopen }) => {
  const [srcimg, setsrcimg] = useState(menu);
  return (
    <div className="navbarcontainer">
      <div className="navcomponentscontainer">
        <div className="navcomponents">
          <img src={logo} id="logo" alt="nothing" />
        </div>
        <div
          className="navcomponents menu"
          onClick={() => {
            setMobilenavopen((prev) => {
              return !prev;
            });
            if (srcimg == menu) {
              setsrcimg(closeicon);
            } else {
              setsrcimg(menu);
            }
          }}
        >
          <img src={srcimg} alt="menu" />
        </div>

        <div className="navcomponents">How we work</div>
        <div className="navcomponents">Blog</div>
        <div className="navcomponents">Account</div>
        <div className="navcomponents">View Plans</div>
      </div>
    </div>
  );
};

export default Navbar;
